// ===========================================
//  For Desktop
// ================================

function setGrid(cols) {
    const grid = document.querySelector(".product-grid")
    if (!grid) return;

    // Remove all possible column classes
    grid.classList.remove('grid--1-col-desktop', 'grid--2-col-desktop', 'grid--4-col-desktop', 'grid--6-col-desktop');

    // Add the selected one
    grid.classList.add(`grid--${cols}-col-desktop`);

    // UI Feedback for buttons
    document.querySelectorAll('.view-btn').forEach(btn => btn.classList.remove('active'));
    event.currentTarget.classList.add('active');
}

// ===========================================
//  For Mobile
// ================================

 document.addEventListener("DOMContentLoaded", function(){

    /* =====================================================
      FILTER BUTTON
      uses Trade theme's hidden menu-drawer
    ===================================================== */
    const filterBtn = document.getElementById("tradeOpenFilter");

    if(filterBtn){

      filterBtn.addEventListener("click", function(){

        const wrapper = document.querySelector(".mobile-facets__wrapper");
        const summary = document.querySelector(".mobile-facets__open-wrapper");

        if(wrapper){
          wrapper.style.display = "block";
        }

        if(summary){
          summary.click();
        }

      });

    }

});

/* =====================================================
    SORTING BUTTON
===================================================== */

document.addEventListener("DOMContentLoaded", function(){

  const openBtn   = document.getElementById("tradeOpenSort");
  const popup     = document.getElementById("tradeSortSheet");
  const closeBtn  = document.getElementById("tradeCloseSort");
  const overlay   = document.querySelector(".trade-sort-overlay");

  if(openBtn && popup){
    openBtn.addEventListener("click", function(e){
      e.preventDefault();
      popup.classList.add("active");
      document.body.classList.add("trade-no-scroll");
    });
  }

  function closeSortPopup(){
    popup.classList.remove("active");
    document.body.classList.remove("trade-no-scroll");
  }

  if(closeBtn){
    closeBtn.addEventListener("click", closeSortPopup);
  }

  if(overlay){
    overlay.addEventListener("click", closeSortPopup);
  }


  document.querySelectorAll(".trade-sort-option").forEach(function(btn){

    btn.addEventListener("click", function(e){

      e.preventDefault();

      const value = this.getAttribute("data-value");
      if(!value) return;

      /* Close popup immediately */
      const popup = document.getElementById("tradeSortSheet");
      if(popup){
        popup.classList.remove("active");
      }

      /* Build new URL */
      const url = new URL(window.location.href);

      url.searchParams.set("sort_by", value);

      /* Optional: reset page to 1 */
      url.searchParams.delete("page");

      /* Redirect */
      window.location.href = url.toString();

    });

  });

});


/* =====================================================
GRID VIEW ICONS
===================================================== */

function setGridMobile(cols) {
  const grid = document.querySelector(".product-grid")
  if (!grid) return;

  // Remove all possible column classes
  grid.classList.remove('grid--2-col-tablet-down','grid--1-col-tablet-down');
  
  // Add the selected one
  grid.classList.add(`grid--${cols}-col-tablet-down`);

  // UI Feedback for buttons
  document.querySelectorAll('.view-btn').forEach(btn => btn.classList.remove('active'));
  event.currentTarget.classList.add('active');
}

/* =====================================================
For Sticky Header
===================================================== */

document.addEventListener("DOMContentLoaded", function(){

  const toolbar = document.querySelector(".trade-mobile-toolbar");
  const header  = document.querySelector(".header-wrapper");

  if(!toolbar || !header) return;

  /* spacer to avoid jump */
  const spacer = document.createElement("div");
  spacer.className = "trade-toolbar-spacer";
  toolbar.parentNode.insertBefore(spacer, toolbar.nextSibling);

  const startTop = toolbar.offsetTop;

  function runSticky(){

    const scrollY = window.scrollY;
    const headerHeight = header.offsetHeight;

    if(scrollY >= startTop - headerHeight){

      toolbar.classList.add("is-fixed");
      toolbar.style.top = headerHeight + "px";

      spacer.classList.add("show");

    }else{

      toolbar.classList.remove("is-fixed");
      toolbar.style.top = "";

      spacer.classList.remove("show");

    }

  }

  window.addEventListener("scroll", runSticky);
  window.addEventListener("resize", runSticky);

  runSticky();

});